import { FrameEditInvoice } from '@Modules/Billing';
import { Badge, defaultIconSize, useLinkedObjectOverlay } from '@synqo/frontend-component-library';
import { IconCurrencyEuro } from '@tabler/icons-react';
import type { ApiOrderRelatedPosition } from '@Model';
import { useCallback, type FC } from 'react';

export type RelatedInvoicePositionProps = {
    position: ApiOrderRelatedPosition;
};

export const RelatedInvoicePosition: FC<RelatedInvoicePositionProps> = ({ position }) => {
    const { onClick: clickLinkedInvoice } = useLinkedObjectOverlay({
        Renderer: FrameEditInvoice,
        canAdd: false,
    });

    const nonNullLinkedInvoiceId = position.related_parent_id ?? '';
    const openInvoiceInModal = useCallback(() => {
        clickLinkedInvoice(nonNullLinkedInvoiceId);
    }, [clickLinkedInvoice, nonNullLinkedInvoiceId]);

    return (
        <Badge variant="brand" onClick={openInvoiceInModal}>
            <IconCurrencyEuro size={defaultIconSize} />
            &nbsp;{position.display_string}
        </Badge>
    );
};
